module.exports = __webpack_public_path__ + "static/media/xlsx.69ac0ace.svg";